<template>
    <div>
        <Nav :isDark.sync="this.isDark" @darkmode="isDark = $event"></Nav>
        <el-button class="to-bottom" circle icon="el-icon-caret-bottom" @click="scrollToBottom"></el-button>
        <div ref="scrollContainer" v-loading="loading" class="container py-2">
            <el-backtop></el-backtop>
            <div :class="!isMobile ? 'w-75' : ''" class="mt-3" style="margin: 0 auto;">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h1 class="fs-24">Elo评分</h1>
                    <div>
                        <el-radio v-model="radio" label="club" @input="changeType">俱乐部</el-radio>
                        <el-radio v-model="radio" label="country" @input="changeType">国家队</el-radio>
                    </div>
                </div>
                <div v-show="this.radio==='club'">
                    <el-input
                            placeholder="按联赛搜索..."
                            v-model="lgName"
                            class="input-with-select mb-3 team-search-input"
                            clearable
                            @keyup.enter.native="searchLgName"
                        >
                            <el-button slot="append" icon="el-icon-search" @click="searchLgName"></el-button>
                        </el-input>
                </div>
                <ux-grid
                ref="plxTable"
                stripe
                show-overflow
                use-virtual
                :data = eloData
                :highlightCurrentRow="true"
                :checkboxConfig="{highlight: true}"
                :edit-config="{trigger: 'click', mode: 'cell'}">
                    <ux-table-column type="index" :width="50"/>
                    <ux-table-column field="name" title="球队">
                        <template slot-scope="scope">
                            {{ scope.row.name }}
                            <sup class="text-muted"><font>
                                {{ radio === 'club' ? '[' + scope.row.currentLeague + ']' : '' }}
                            </font></sup>
                        </template>
                    </ux-table-column>
                    <ux-table-column field="elo" title="评分" :width="80">
                        <template slot-scope="scope">
                            {{ parseFloat(scope.row.elo).toFixed(0) }}
                        </template>
                    </ux-table-column>
                </ux-grid><!--球队数据表格-->
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
import Nav from '../components/comment/nav.vue'
import Footer from '../components/comment/footer.vue'
import { checkDevice } from '../utils/utils.js';
import { getCountryEloUrl, getTop100ClubEloUrl,searchClubEloByLgNameUrl } from '../constants/http.config.js';
export default {
    components: {
        Nav,
        Footer
    },
    data() {
        return {
            loading: true,
            isDark: false,
            isMobile: false,
            eloData: [],
            radio: 'club',
            lgName: '',
        }
    },
    mounted() {
        this.isMobile = checkDevice();
        this.fetchClubElo();
    },
    methods: {
        scrollToBottom(){
            window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
        },
         fetchCountryElo() {
            this.loading = true;
            fetch(getCountryEloUrl)
                .then(response => response.json())
                .then(data => {
                    this.eloData = data.data;
                    // console.log(this.eloData);
                    this.loading = false;
                })
                .catch(error => {
                    console.error('Error fetching country elo:', error);
                    this.loading = false;
                });
        },
        changeType() {
            if (this.radio === 'country') {
                this.eloData = [];
                this.fetchCountryElo();
            } else if (this.radio === 'club') {
                // 获取俱乐部Elo评分的逻辑
                this.eloData = [];
                this.fetchClubElo();
            }
        },
        fetchClubElo() {
            this.loading = true;
            fetch(getTop100ClubEloUrl)
                .then(response => response.json())
                .then(data => {
                    this.eloData = data.data;
                    // console.log(this.eloData);
                    this.loading = false;
                })
                .catch(error => {
                    console.error('Error fetching club elo:', error);
                    this.loading = false;
                });
        },
        searchLgName() {
            // 按联赛搜索的逻辑
            this.eloData = [];
            this.loading = true;
            fetch(searchClubEloByLgNameUrl + '?league=' + this.lgName)
                .then(response => response.json())
                .then(data => {
                    this.eloData = data.data;
                    // console.log(this.eloData);
                    this.loading = false;
                })
                .catch(error => {
                    console.error('Error fetching club elo by league name:', error);
                    this.loading = false;
                });
        },
    }
}
</script>
<style lang="scss" scoped>
    @import '../assets/sass/global.scss';
    ::v-deep .elx-header--row .col_4 .elx-cell, ::v-deep .elx-header--row .col_2 .elx-cell {justify-content: center;}
    ::v-deep .col_2, ::v-deep .col_4 { text-align: center!important; }
</style>